import { SidebarDockButton } from "@/SideNavDashboards/SideNavHeader/SidebarDockButton";
import logo from "@/logo-ncm.png";
import { MeteomaticsLogoPositive } from "@/meteomatics-logo";
import type React from "react";
import "./SideNavHeader.scss";

interface SideNavHeaderProps {
  showCustomLogo?: boolean | undefined;
}

export const SideNavHeader: React.FC<SideNavHeaderProps> = ({ showCustomLogo }: SideNavHeaderProps) => {
  return (
    <div className="side-nav-header">
      <div className="side-nav-header__top">
        <div className="side-nav-header__top-logo">
          {showCustomLogo ? <img height="60" src={logo} alt="logo ncm" /> : <MeteomaticsLogoPositive />}
        </div>
      </div>
    </div>
  );
};
